<template>
  <div id="manifiesto-content">
    <p class="justificado">
      De conformidad con los artículos 23 y 26 fracción XII de Ley de Transparencia y
      Acceso a la Información Pública para el Estado de Guanajuato; artículos 3
      fracciones VII y VIII, 8, 9, 13, 14 y 19 de la Ley de Protección de Datos Personales
      en Posesión de Sujetos Obligados para el Estado de Guanajuato; el Capítulo III,
      Sección Primera artículos 27, párrafos primero y tercero, 28, 29, 30, 32, 33, 34, 46
      y 48 segundo párrafo de la Ley de Responsabilidades Administrativas para el
      Estado de Guanajuato; y en el Capítulo Cuarto, párrafos Decimoctavo,
      Decimonoveno y Vigésimo del Acuerdo por el que se modifican los anexos primero
      y segundo del acuerdo por el que el Comité Coordinador del Sistema Nacional
      Anticorrupción emite el formato de declaraciones: de situación patrimonial y de
      intereses; y expide las normas e instructivo para su llenado y presentación, de
      fecha 07 de agosto de 2019; así como el Acuerdo del 11 de diciembre de 2019,
      publicados en el Diario Oficial de la Federación el 23 de septiembre y 24 de
      diciembre de 2019, respectivamente, emitidos por el Comité Coordinador la
      Secretaría Ejecutiva del Sistema Nacional Anticorrupción; así como el Acuerdo
      número CCSE/002/2021, publicado en el Periódico Oficial del Gobierno del Estado
      de Guanajuato número 82 segunda parte, del 26 de abril de 2021, mediante el
      cual, el Comité Coordinador del Sistema Estatal Anticorrupción de Guanajuato, a
      propuesta del Comité de Participación Ciudadana aprueba la adopción de los
      formatos de declaración de situación patrimonial y de intereses, así como las
      normas e instructivos para su llenado y presentación, aprobados por el Comité
      Coordinador del Sistema Nacional Anticorrupción. Con fundamento en lo anterior,
      se le solicita manifieste:</p>

    <p class="text-center d-flex justify-content-center m-0 p-2">
      <button type="button" class="swal2-confirm order-2 swal2-styled swal2-default-outline" style="display: inline-block; background-color: rgb(48, 133, 214);" aria-label="" @click.prevent="autorizacion(true)">Autorizo</button>
      <button type="button" class="swal2-deny order-3 swal2-styled swal2-default-outline" style="display: inline-block; background-color: rgb(255, 150, 74);" aria-label="" @click.prevent="autorizacion(false)">No Autorizo</button>
    </p>

    <p class="justificado">
      A la <b>Secretaría de la Transparencia y Rendición de Cuentas</b> para que en las
      Plataformas Nacional y Estatal de Transparencia, se publique en versión
      pública la presente declaración patrimonial y de intereses, salvaguardando en
      todo momento la protección de mis datos personales, ello en razón de ser el titular
      de dicha información, por lo que manifiesto libremente que conozco la naturaleza y
      alcance de dicha autorización o negativa, en el entendido de que en el supuesto
      de haber autorizado la publicación, en cualquier momento puedo revocar el
      consentimiento aquí otorgado, mediante aviso o notificación presentado por escrito
      ante la propia Secretaría de la Transparencia y Rendición de Cuentas.
    </p>
    <p class="justificado">

      Leído lo anterior, <b>{{ data.nombres }}</b>, con RFC <b>{{ data.rfc }}</b>, persona que emitiré mi declaración
      patrimonial y de intereses, manifiesto de conformidad que estoy enterado (a) del
      contenido, alcance, efectos y fuerza legal del presente instrumento.

    </p>
  </div>
</div></template>
<script>
export default {
  props: {
    data: {
      type: [String, Object]
      // default: () => ['', {}]
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    autorizacion (v = false) {
      this.$parent.$emit('autorizacion', {autorizacion: v})
    }
  },
  created () { },
  mounted () { }
}

</script>
<style>
#manifiesto-content {
  padding: 0px 40px 40px 40px;
}

.justificado {
  position: relative;
  top: 15px;
  width: 100%;
  text-align: justify;
  text-justify: auto;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 1.8;
  padding: 10px;
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Manifiesto.component.vue